import React, { useContext, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
// import { BrowserRouter } from 'react-router-dom';
import { Router } from 'app/src/utils/routing';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components/native';
import AuthContext from './contexts/AuthContext';
import { buttonBackground } from './styles/colors';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './routes';
import moment from 'moment';
import { MainContainer } from './elements';
import Header from './Header';

import {
  SafeAreaView,
  ScrollView,
  Text,
  View,
  Pressable,
} from 'react-native';

const Screen = styled(View)`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Content = styled(View)`
  flex: 1;
  flex-direction: column;
`;

const Footer = styled(View)`
  border-top: 1px solid  ${buttonBackground};
  padding-top: 16px;
  text-align: right;
`;

const NewVersion = styled(View)`
  background-color: yellow;
`;

const NewVersionText = styled(Text)`
  color: black;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

const NewVersionButtons = styled(View)`
  flex-direction: row;
  gap: 40px;
  justify-content: center;
`;

const NewVersionButton = styled(View)`
  border-width: 2px;
  border-style: solid;
  border-color: red;
  padding: 6px;
  background-color: white;
`;

const NewVersionLabel = styled(Text)`
  color: black;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

const Main = () => {
  const {
    apolloClient,
    isLoggedIn,
    showNewVersion,
    setIgnoreVersion,
  } = useContext(AuthContext);

  const reloadPage = () => {
    window.location.href =
      window.location.href + `?reload=${new Date().getTime()}`;
  };

  return (
    <Router>
      <ApolloProvider client={apolloClient}>
        <SafeAreaView>
          <ScrollView>
            <View>
              <Helmet titleTemplate="Equiplinc Seller Portal | %s" defaultTitle="Equiplinc Seller Portal">
                <meta charSet="utf-8" />
              </Helmet>
              <Screen>
                {showNewVersion && (
                  <NewVersion>
                    <NewVersionText>
                      New updates are available.
                    </NewVersionText>
                    <NewVersionButtons>
                      <Pressable onPress={reloadPage}>
                        <NewVersionButton>
                          <NewVersionLabel>Reload Page</NewVersionLabel>
                        </NewVersionButton>
                      </Pressable>
                      <Pressable
                        onPress={() => setIgnoreVersion(new Date().getTime())}
                      >
                        <NewVersionButton>
                          <NewVersionLabel>Ignore</NewVersionLabel>
                        </NewVersionButton>
                      </Pressable>
                    </NewVersionButtons>
                  </NewVersion>
                )}
                {/* <Navigation /> */}
                {/* <UserMenuAndContent> */}
                  {/* <UserMenu>
                    <Icon
                      icon={faChevronDown}
                      style={{fontSize: '0.8rem', marginRight: 0, cursor: 'pointer'}}
                      onClick={() => setShowAccountMenu(!showAccountMenu)}
                    />
                  </UserMenu> */}
                  <Header isLoggedIn={isLoggedIn} />
                  <Content>
                    <ErrorBoundary>
                      <MainContainer>
                        <Routes />
                      </MainContainer>
                    </ErrorBoundary>
                  </Content>

                  {/* <Footer>
                    <Text>
                      {`Copyright Equiplinc © ${moment().format('YYYY')}`}
                    </Text>
                  </Footer> */}
                {/* </UserMenuAndContent> */}
              </Screen>
            </View>
          </ScrollView>
        </SafeAreaView>
      </ApolloProvider>
    </Router>
  );
};

export default Main;
